import api from '@/plugins/api/instance'

const state = () => ({
  available: {
    campingPlaces: [],
    models: [],
    layouts: [],
    rentalStations: [],
    serviceStations: [],
    vehicleTypes: []
  },
  dealername: '',
  location: '',
  latitude: '',
  longitude: '',
  radius: 1000,
  neLatitude: '',
  neLongitude: '',
  swLatitude: '',
  swLongitude: '',
  services: [],
  divisions: [],
  models: [],
  model: '',
  layouts: [],
  country: '',
  modelYear: ''
})

const getters = {
  getParams: (state, getters, rootState) => {
    const params = {}
    params['location[radiusTo]'] = state.radius
    if (state.latitude && state.longitude) {
      params['location[latitude]'] = state.latitude
      params['location[longitude]'] = state.longitude
    } else if (state.dealername) {
      params.addressLine1 = state.dealername
    } else if (state.neLatitude && state.neLongitude && state.swLatitude && state.swLongitude) {
      params['location[latitudeA]'] = state.swLatitude
      params['location[longitudeA]'] = state.swLongitude
      params['location[latitudeB]'] = state.neLatitude
      params['location[longitudeB]'] = state.neLongitude
    }
    if (['8300'].includes(rootState.brand)) {
      params.services = [10, 190]
    } else if (state.services.length) {
      params.services = state.services
    }
    if (state.models.length) {
      params['vehicles.model'] = state.models
    }
    if (state.divisions.length) {
      params['brandDivisions.division'] = state.divisions
    }
    if (state.model) {
      params['vehicles.model.name'] = state.model
    }
    if (state.layouts.length) {
      const lengths = []
      const layouts = []
      state.layouts.forEach(item => {
        const splitItem = item.split(' ')
        if (!lengths.includes(splitItem[0])) lengths.push(splitItem[0])
        if (!layouts.includes(splitItem[1])) layouts.push(splitItem[1])
      })
      params['vehicles.length'] = lengths
      params['vehicles.layout'] = layouts
    }
    if (state.modelYear) {
      params['vehicles.year'] = state.modelYear
    }
    if (state.country) {
      params.country = state.country
    }
    return params
  }
}

const mutations = {
  setDealername (state, payload) {
    state.dealername = payload
  },
  setLocation (state, payload) {
    state.location = payload
  },
  setLatitude (state, payload) {
    state.latitude = payload
  },
  setLongitude (state, payload) {
    state.longitude = payload
  },
  setNeLatitude (state, payload) {
    state.neLatitude = payload
  },
  setNeLongitude (state, payload) {
    state.neLongitude = payload
  },
  setSwLatitude (state, payload) {
    state.swLatitude = payload
  },
  setSwLongitude (state, payload) {
    state.swLongitude = payload
  },
  setAvailableCampingPlaces (state, payload) {
    state.available.campingPlaces = [...payload]
  },
  setAvailableModels (state, payload) {
    state.available.models = [...payload]
  },
  setAvailableLayouts (state, payload) {
    state.available.layouts = [...payload]
  },
  setAvailableRentalStations (state, payload) {
    state.available.rentalStations = [...payload]
  },
  setAvailableServiceStations (state, payload) {
    state.available.serviceStations = [...payload]
  },
  setAvailableVehicleTypes (state, payload) {
    state.available.vehicleTypes = [...payload]
  },
  setDivisions (state, payload) {
    state.divisions = [...payload]
  },
  setModels (state, payload) {
    state.models = [...payload]
  },
  setServices (state, payload) {
    state.services = [...payload]
  },
  setModel (state, payload) {
    state.model = payload
  },
  setLayouts (state, payload) {
    state.layouts = [...payload]
  },
  setCountry (state, payload) {
    state.country = payload
  },
  setModelYear (state, payload) {
    state.modelYear = payload
  }
}

const actions = {
  resetCountry ({ commit }) {
    commit('setCountry', '')
  },
  updateDealername ({ commit }, payload) {
    commit('setDealername', payload)
  },
  resetDealername ({ commit }) {
    commit('setDealername', '')
  },
  updateLocation ({ commit }, payload) {
    commit('setCountry', payload.country)
    commit('setLocation', payload.location)
    commit('setLatitude', payload.latitude)
    commit('setLongitude', payload.longitude)
  },
  resetLocation ({ commit }) {
    commit('setLocation', '')
    commit('setLatitude', '')
    commit('setLongitude', '')
  },
  updateBounds ({ commit }, payload) {
    commit('setNeLatitude', payload.ne.latitude)
    commit('setNeLongitude', payload.ne.longitude)
    commit('setSwLatitude', payload.sw.latitude)
    commit('setSwLongitude', payload.sw.longitude)
  },
  resetBounds ({ commit }) {
    commit('setNeLatitude', '')
    commit('setNeLongitude', '')
    commit('setSwLatitude', '')
    commit('setSwLongitude', '')
  },
  async get ({ commit, state, rootState }) {
    try {
      const response = await api.get('filter', {
        params: {
          brand: rootState.brand
        }
      })
      const brands = response.data['hydra:member'].models
      const models = Object.keys(brands).map(brandsKey => {
        const divisions = brands[brandsKey]
        const brand = Object.keys(divisions).map(divisionKey => {
          return { title: divisionKey.split('|')[1], options: divisions[divisionKey] }
        })
        return { title: brandsKey.split('|')[1], fieldset: brand }
      })
      commit('setAvailableModels', models)
      commit('setAvailableCampingPlaces', response.data['hydra:member'].campingPlaces)
      commit('setAvailableRentalStations', response.data['hydra:member'].rentalStations)
      commit('setAvailableServiceStations', response.data['hydra:member'].serviceStations)
      commit('setAvailableVehicleTypes', response.data['hydra:member'].vehicleTypes.filter(item => item.id !== '07'))
      return response
    } catch (e) {
      commit('setErrors', e, { root: true })
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
